<template>
  <div v-if="allowAccess" class="container" v-loading="containerLoading" element-loading-text="Drawing...please wait">
    <el-container style="height: 100%">
      <el-header class="header" height="100px">
        <div class="headerLeft">
          <el-tooltip effect="light" content="Back">
            <el-icon class="iconLeft" size="32" color="#999999" @click="onBack">
              <ArrowLeftBold/>
            </el-icon>
          </el-tooltip>
          <img src="@/assets/logo.png" style="height: 60px;" alt=""/>
          <!--          <div class="info">-->
          <!--            <div>Custom Personalized T-Shirts High Quality Oval-->
          <!--              Digital Print on Demand for Cotton Tees-->
          <!--            </div>-->
          <!--            <div class="code">Design Id: <b>POD-ODP-CCSS690-C12</b></div>-->
          <!--          </div>-->
          <!-- <el-divider direction="vertical"/>-->
        </div>
        <div class="headerCenter">
          <el-steps
              :active="1"
              align-center
              finish-status="success"
          >
            <el-step title="Product"/>
            <el-step title="Design"/>
            <el-step title="Pricing"/>
          </el-steps>
        </div>
        <div class="headerRight">
          <div class="undoRedo">
            <el-tooltip effect="light" :content="currentHistoryIndex<=0?'Cannot Undo':'Undo'">
              <el-button text :disabled="currentHistoryIndex<=0" @click="onUndo">
                <el-icon :size="36">
                  <UndoIcon/>
                </el-icon>
              </el-button>
            </el-tooltip>
            <el-tooltip effect="light"
                        :content="currentHistoryIndex===editHistory.length-1?'Cannot Redo':'Redo'">
              <el-button text :disabled="currentHistoryIndex===editHistory.length-1"
                         @click="onRedo">
                <el-icon :size="36">
                  <RedoIcon/>
                </el-icon>
              </el-button>
            </el-tooltip>
          </div>
        </div>
      </el-header>
      <el-container class="editorArea">
        <el-aside class="leftArea menus" width="80px">
          <div class="menuItem" :class="activeTab===1&&'active'" @click="()=>activeTab=1">
            <el-icon size="30px">
              <Upload/>
            </el-icon>
            <span>Upload</span>
          </div>
          <div class="menuItem" :class="activeTab===2&&'active'" @click="()=>activeTab=2">
            <el-icon size="22px">
              <FontIcon/>
            </el-icon>
            <span>Text</span>
          </div>
          <div class="menuItem" :class="activeTab===3&&'active'" @click="()=>activeTab=3">
            <el-icon size="24px">
              <LayerIcon/>
            </el-icon>
            <span>Layers</span>
          </div>
          <div class="menuItem" :class="activeTab===4&&'active'" @click="onClickSaved(4)">
            <el-icon size="30px">
              <ImageIcon/>
            </el-icon>
            <span>Saved<br/>Designs</span>
          </div>
          <div class="menuItem" :class="activeTab===5&&'active'" @click="onClickClipart(5)">
            <el-icon size="30px">
              <ClipartIcon/>
            </el-icon>
            <span>Clipart</span>
          </div>
        </el-aside>
        <el-aside class="leftArea" width="440px" v-if="activeTab===1">
          <div class="areaTitle">Add Your Artwork</div>
          <div class="mainArea">
            <div class="row">
              <span>PNG is required.</span> It supports transparency and is ideal for our printing process.
            </div>
            <div class="row">
              <b>Resolution:</b> 300 DPI (recommended)
            </div>
            <div class="row">
              <b>Dimensions:</b> 5400 x 6600 pixels (maximum)
            </div>
            <div class="actions">
              <el-upload :limit="0" :show-file-list="false" accept=".png" :before-upload="beforeUpload"
                         :http-request="httpRequest">
                <el-button plain
                           :disabled="uploading || editorData.length<=0 || imageEditorRef?.getCurrentData()['materials']?.length>=LayersMaximum">
                  <el-icon size="28px">
                    <Upload/>
                  </el-icon>
                  Upload Artwork
                </el-button>
              </el-upload>
              <div v-if="uploading" class="custom-progress">
                <el-progress
                    :percentage="progressPercentage"
                    color="#3A499D"
                    :stroke-width="12"
                    striped
                />
                <div class="progress-info">
                  <span>{{ uploadSpeed }}</span>
                  <span>Remaining: {{ remainingTime }}</span>
                </div>
              </div>
            </div>
          </div>
        </el-aside>
        <el-aside class="leftArea" width="440px" v-if="activeTab===2">
          <div class="areaTitle">Text Edit</div>
          <div class="mainArea rightArea">
            <div class="actions marginBottom16">
              <InputDialog
                  v-model="openInputDialog"
                  :data="dialogText"
                  @submit="onInputDialogSubmit"
              />
              <el-input
                  type="textarea"
                  autocomplete="off"
                  style="font-size: 18px;margin-bottom: 16px;"
                  clearable
                  :maxlength="20"
                  v-model="inputValue"
                  placeholder="input"
                  show-word-limit
              />
              <div class="flexRow marginBottom16">
                <div class="iconOption" style="width: 140px" @click="onAddText">
                  <el-icon size="22">
                    <Plus/>
                  </el-icon>
                  <div>Add New Text</div>
                </div>
              </div>
            </div>
          </div>
        </el-aside>
        <el-aside class="leftArea" width="440px" v-if="activeTab===3">
          <div class="layersTitle">
            <b>Layers</b>
            <span :class="imageEditorRef?.getCurrentData()['materials']?.length>=LayersMaximum&&'warning'">
              Maximum {{ LayersMaximum }} layers</span>
          </div>
          <div class="layersList">
            <vue-draggable
                v-model="sourceMaterialList"
                item-key="id"
                :animation="300"
                @end="onDragEnd"
            >
              <template #item="{ element }">
                <div class="layerItem" :class="currentLayer===element.id?'active':''"
                     @click="onClickLayerItem(element.id)">
                  <div class="itemLeft">
                    <el-icon size="18px" class="leftIcon">
                      <DragIcon/>
                    </el-icon>
                    <img class="layerImg" alt=""
                         :src="element['materialType'] === 1? element.materialUrl:textLayerIcon"/>
                    <span>{{ element['materialType'] === 1 ? "Image Layer" : element.content }}</span>
                  </div>
                  <el-icon class="rightIcon" size="18px" color="#666666" @click="handleDeleteLayer(element.id)">
                    <Delete/>
                  </el-icon>
                </div>
              </template>
            </vue-draggable>
            <el-empty
                v-if="_.isEmpty(sourceMaterialList)"
                :image-size="68"
                description="No layers"
                style="height: 100%"
            />
          </div>
          <div class="rightArea" v-if="sourceMaterialInfo['materialType'] === 1">
            <div class="flexRow">
              <div class="iconOption" @click="handleCopy">
                <el-icon size="22">
                  <DocumentCopy/>
                </el-icon>
                <div>Copy</div>
              </div>
            </div>
            <el-divider></el-divider>
            <div class="flexRow">
              <div class="cation">Direction</div>
              <div class="iconSingle" @click="handleVerticalCenter">
                <el-image :src="verticalCenter" style="width: 24px"/>
              </div>
              <div class="iconSingle" @click="handleHorizontalCenter">
                <el-image :src="horizontal" style="width: 24px"/>
              </div>
            </div>
            <el-divider></el-divider>
            <div class="printSizeHeader">
              <div class="title" style="margin-bottom: 0">Print Size</div>
              <div class="printSizeLock">
                <span class="printSizeLockLabel">Lock ratio</span>
                <el-switch v-model="lockAspectRatio" @change="handleLockAspectRatioChange" size="small"/>
              </div>
            </div>
            <div class="printSizeGrid">
              <div class="printSizeItemInline">
                <div class="printSizeLabel">Width</div>
                <el-input
                    v-model="printWidth"
                    :controls="false"
                    style="flex: 1"
                    @change="handleChangePrintWidth"
                >
                  <template #suffix>in</template>
                </el-input>
              </div>
              <div class="printSizeItemInline">
                <div class="printSizeLabel">Height</div>
                <el-input
                    v-model="printHeight"
                    :controls="false"
                    style="flex: 1"
                    @change="handleChangePrintHeight"
                >
                  <template #suffix>in</template>
                </el-input>
              </div>
            </div>
            <el-divider></el-divider>
            <div class="printSizeHeader">
              <div class="title" style="margin-bottom: 0">Transform</div>
            </div>
            <div class="printSizeGrid">
              <div class="printSizeItemInline">
                <div class="printSizeLabel wide">Rotate</div>
                <el-input
                    v-model="rotateDeg"
                    :controls="false"
                    style="flex: 1"
                    @change="handleChangeRotate"
                >
                  <template #suffix>deg</template>
                </el-input>
              </div>
              <div class="printSizeItemInline">
                <div class="printSizeLabel wide">Scale</div>
                <el-input
                    v-model="scalePercent"
                    :controls="false"
                    style="flex: 1"
                    @change="handleChangeScale"
                >
                  <template #suffix>%</template>
                </el-input>
              </div>
            </div>
            <el-divider></el-divider>
            <div class="title">Position</div>
            <div class="printSizeGrid">
              <div class="printSizeItemInline">
                <div class="printSizeLabel">Left</div>
                <el-input
                    v-model="printLeft"
                    :controls="false"
                    style="flex: 1"
                    @change="handleChangePrintLeft"
                >
                  <template #suffix>in</template>
                </el-input>
              </div>
              <div class="printSizeItemInline">
                <div class="printSizeLabel">Top</div>
                <el-input
                    v-model="printTop"
                    :controls="false"
                    style="flex: 1"
                    @change="handleChangePrintTop"
                >
                  <template #suffix>in</template>
                </el-input>
              </div>
            </div>
          </div>
          <div class="rightArea" v-if="sourceMaterialInfo['materialType'] === 2">
            <div class="flexRow marginBottom16">
              <div class="iconOption" @click="handleCopy">
                <el-icon size="22">
                  <DocumentCopy/>
                </el-icon>
                <div>Copy</div>
              </div>
              <div class="iconOption" @click="onStartEditText">
                <el-icon size="22">
                  <Edit/>
                </el-icon>
                <div>Edit</div>
              </div>
            </div>
            <div v-if="isTextUpdate" class="marginBottom16">
              <el-input
                  type="textarea"
                  autocomplete="off"
                  style="font-size: 18px;margin-bottom: 8px;"
                  clearable
                  :maxlength="20"
                  v-model="inputValue"
                  placeholder="input"
                  show-word-limit
              />
              <div class="flexRow">
                <div class="iconOption" @click="onEditSave">
                  <el-icon size="22">
                    <Select/>
                  </el-icon>
                  <div>Save</div>
                </div>
                <div class="iconOption" @click="onCancelEditText">
                  <el-icon size="22">
                    <Close/>
                  </el-icon>
                  <div>Cancel</div>
                </div>
              </div>
            </div>
            <div class="title">Font Family</div>
            <div class="flexRow marginBottom16">
              <font-select
                  :data="fontList"
                  style="width: 190px"
                  v-model="familyValue"
                  @change="handleChangeFamily"
              />
              <div class="iconSingle" @click="handleChangeBold">
                <el-image :src="bold" style="width: 24px"/>
              </div>
              <div class="iconSingle" @click="handleChangeUnderLine">
                <el-image :src="underline" style="width: 24px"/>
              </div>
              <div class="iconSingle" @click="handleChangeItalic">
                <el-image :src="italic" style="width: 24px"/>
              </div>
              <div class="iconSingle" @click="handleChangeLineThrough">
                <el-image :src="strikethrough" style="width: 24px"/>
              </div>
            </div>
            <div class="flexRow marginBottom16">
              <div class="caption" style="width: 80px;">Font Size</div>
              <el-input-number :controls="true" v-model="fontSize" align="left" :min="1" :max="200"
                               style="width: 120px"
                               @change="handleChangeSize"/>
              <div class="iconSingle" @click="handleChangeAlignLeft">
                <el-image :src="left" style="width: 24px"/>
              </div>
              <div class="iconSingle" @click="handleChangeAlignCenter">
                <el-image :src="center" style="width: 24px"/>
              </div>
              <div class="iconSingle" @click="handleChangeAlignRight">
                <el-image :src="right" style="width: 24px"/>
              </div>
            </div>
            <div class="flexRow marginBottom16">
              <span class="caption">Letter Spacing</span>
              <el-slider
                  style="flex: 1"
                  :min="1"
                  v-model="letterSpacing"
                  @change="handleChangeLetterSpacing"
              />
            </div>
            <div class="flexRow marginBottom16">
              <span class="caption">Line Height</span>
              <el-slider
                  style="flex: 1"
                  :min="1"
                  :max="5"
                  :step="0.2"
                  v-model="lineHeight"
                  @change="handleChangeLineHeight"
              />
            </div>
            <el-divider></el-divider>
            <div class="title">Color</div>
            <div class="color-picker marginBottom16">
              <el-color-picker v-model="color" @change="handleChangeColor"/>
              <el-divider direction="vertical" style="margin: 0"/>
              <template v-for="item in fixedColor" :key="item">
                <div
                    class="color-item"
                    :style="{ background: item }"
                    @click="handleChangeColor(item)"
                ></div>
              </template>
            </div>
            <el-divider></el-divider>
            <div class="flexRow">
              <div class="caption" style="width: 80px;">Direction</div>
              <div class="iconSingle" @click="handleVerticalCenter">
                <el-image :src="verticalCenter" style="width: 24px"/>
              </div>
              <div class="iconSingle" @click="handleHorizontalCenter">
                <el-image :src="horizontal" style="width: 24px"/>
              </div>
            </div>
            <el-divider></el-divider>
            <div class="printSizeHeader">
              <div class="title" style="margin-bottom: 0">Print Size</div>
              <div class="printSizeLock">
                <span class="printSizeLockLabel">Lock ratio</span>
                <el-switch v-model="lockAspectRatio" @change="handleLockAspectRatioChange" size="small"/>
              </div>
            </div>
            <div class="printSizeGrid">
              <div class="printSizeItemInline">
                <div class="printSizeLabel">Width</div>
                <el-input
                    v-model="printWidth"
                    style="flex: 1"
                    @change="handleChangePrintWidth"
                >
                  <template #suffix>in</template>
                </el-input>
              </div>
              <div class="printSizeItemInline">
                <div class="printSizeLabel">Height</div>
                <el-input
                    v-model="printHeight"
                    style="flex: 1"
                    @change="handleChangePrintHeight"
                >
                  <template #suffix>in</template>
                </el-input>
              </div>
            </div>
            <el-divider></el-divider>
            <div class="title">Position</div>
            <div class="printSizeGrid">
              <div class="printSizeItemInline">
                <div class="printSizeLabel">Left</div>
                <el-input
                    v-model="printLeft"
                    :controls="false"
                    style="flex: 1"
                    @change="handleChangePrintLeft"
                >
                  <template #suffix>in</template>
                </el-input>
              </div>
              <div class="printSizeItemInline">
                <div class="printSizeLabel">Top</div>
                <el-input
                    v-model="printTop"
                    :controls="false"
                    style="flex: 1"
                    @change="handleChangePrintTop"
                >
                  <template #suffix>in</template>
                </el-input>
              </div>
            </div>
          </div>
        </el-aside>
        <el-aside class="leftArea savedDesignsArea" width="440px" v-if="activeTab===4">
          <div class="areaTitle">Saved Designs({{ savedDesignsTotal }})</div>
          <div class="savedArea" ref="savedAreaRef" v-loading="savedAreaLoading"
               element-loading-custom-class="loadingArea" @scroll.passive="handleSavedScroll">
            <el-empty v-if="savedDesignsTotal === 0" description="No saved designs" :image-size="68"/>
            <div v-else class="savedVirtualHolder" :style="{ height: `${savedVirtualHeight}px` }">
              <div class="savedVirtualList" :style="{ transform: `translateY(${savedVirtualOffset}px)` }">
                <div class="savedItem" v-for="item in savedVisibleDesigns"
                     :key="item.thumbFileName ? `${item.folderPath}/${item.thumbFileName}` : item.imageUrl">
                  <div class="savedItemImage">
                    <img alt="" :src="item.imageUrl" @click="onClickSavedDesign(item)"/>
                    <el-icon class="savedDeleteBtn" :size="16" title="Delete"
                             @click.stop="onDeleteSavedDesign(item)">
                      <Delete/>
                    </el-icon>
                  </div>
                  <div class="title">{{ dayjs(item.createTime).format("YYYY-MM-DD HH:mm:ss") }}</div>
                  <div class="content">{{ `${item.width} × ${item.height} px` }}</div>
                  <div class="content">{{ item.fileSizeStr }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="savedPagination" v-if="savedDesignsTotal > 0">
            <el-pagination
                small
                background
                layout="prev, pager, next"
                :pager-count="5"
                :current-page="savedPage"
                :page-size="savedPageSize"
                :total="savedDesignsTotal"
                @current-change="handleSavedPageChange"
            />
            <el-select v-model="savedPageSize" size="small" class="savedPageSize"
                       @change="handleSavedPageSizeChange">
              <el-option v-for="size in savedPageSizeOptions" :key="size" :label="`${size} / page`" :value="size"/>
            </el-select>
          </div>
        </el-aside>
        <el-aside class="leftArea" width="440px" v-if="activeTab===5">
          <div class="mainArea" style="min-height: 400px" v-loading="clipartLoading">
            <el-input
                size="large"
                v-model="clipartSearchValue"
                placeholder="Search Clipart"
                :suffix-icon="Search"
                @input="onClipartSearchInput"
            />
            <div v-for="(item,index) in clipartList" :key="index">
              <el-divider></el-divider>
              <div class="clipartItem">
                <div class="title">
                  {{ item.name }}
                </div>
                <div class="list">
                  <img v-for="imgItem in item.clipart" :key="imgItem.name" alt="" :src="imgItem.image"
                       @click="onClickClipartImage(imgItem)"/>
                </div>
              </div>
            </div>
          </div>
        </el-aside>
        <!--        <el-aside class="rightArea" width="400px">-->
        <!--          <el-empty-->
        <!--              v-if="_.isEmpty(sourceMaterialInfo)"-->
        <!--              :image-size="68"-->
        <!--              description="No layer selected"-->
        <!--              style="height: 100%"-->
        <!--          />-->
        <!--        </el-aside>-->
        <el-main class="centerArea" style="padding-top: 0" v-loading="fontLoading"
                 element-loading-text="Initializing...">
          <el-header class="positionRow" height="80px">
            <el-segmented :model-value="currentPosition" :options="positions" size="large" :disabled="editorData.length<=0" @change="onPositionChange">
              <template #default="opt">
                <div style="display: flex; align-items: center; justify-content: center; gap: 4px; white-space: nowrap;">
                  <span>{{ opt.item.label }}</span>
                  <!--
                    加价提示逻辑：
                    - Back tab：正面有素材时显示 Back 加价
                    - Back Collar tab：Back Collar 自身有素材时显示加价
                    - Front tab：正面无素材但背面（Back 或 Back Collar）有素材时，显示 Back 加价
                    - 选中时用白色，未选中时用红色
                  -->
                  <span :style="{ color: currentPosition === opt.item.value ? '#FFFFFF' : '#B80801' }" v-if="submitList.length>=2 && (
                    (opt.item.value===2 && submitList.find(x=>x.id==1)?.['materials']?.length>0) ||
                    (opt.item.value===3 && (submitList.find(x=>x.id==3)?.['materials']?.length>0 || submitList.find(x=>x.id==1)?.['materials']?.length>0)) ||
                    (opt.item.value===1 && !submitList.find(x=>x.id==1)?.['materials']?.length && submitList.find(x=>x.id==2)?.['materials']?.length>0)
                  )">+${{ opt.item.value===1 ? positions.find(p=>p.value===2)?.price : positions.find(p=>p.value===opt.item.value)?.price }}</span>
                </div>
              </template>
            </el-segmented>
          </el-header>
          <div class="editorContainer">
            <ImageEditor v-if="editorData.length>0" ref="imageEditorRef" :width="600" :height="600" :list="editorData"
                         :canImageEdit="false" :canUpdateFrame="false" :limitCount="LayersMaximum"
                         :guideLineConfig="currentPosition === 3 ? null : { type: 'vertical', gap: 35, printWidth: 45 }"
                         @exceedsLimit="onExceedsLimit"
                         @material-edit="handleMaterialEdit" @change="handleEditorChange"
                         @changeOperation="onOperation"/>
            <!--          @doubleClickText="onDoubleClickText"-->
            <el-empty
                v-else
                :image-size="68"
                description="Not initialized"
                style="height: 100%"
            />
          </div>
          <el-footer class="footerBar">
            <!--默认显示正面的价格，如果背面产生定制，需再加背面的价格获得总价-->
            <div class="unitPrice">
              <span>Unit Price:</span>
              <b>${{ unitPrice }}</b>
            </div>
            <el-button class="finishButton" :disabled="editorData.length<=0 || !hasAnyDesign" dark color="#3A499D" @click="onFinish">
              Finish
            </el-button>
          </el-footer>
        </el-main>
      </el-container>
    </el-container>
  </div>
  <div v-else class="error-container">
    <h1>Access denied</h1>
  </div>
</template>

<script setup>
  // region import
  import { ImageEditor } from "@jzg-cn/leafer-image-editor";
  import "@jzg-cn/leafer-image-editor/dist/leafer-image-editor.css";
  import UndoIcon from "@/components/icons/UndoIcon.vue";
  import RedoIcon from "@/components/icons/RedoIcon.vue";
  import {ArrowLeftBold, Close, Delete, DocumentCopy, Edit, Plus, Search, Select, Upload} from "@element-plus/icons-vue";
  import {nextTick, onBeforeMount, onBeforeUnmount, onMounted, ref, watch, computed} from "vue";
  import FontIcon from "@/components/icons/FontIcon.vue";
  import DragIcon from "@/components/icons/DragIcon.vue";
  import bold from '@/assets/bold.svg';
  import underline from '@/assets/underline.svg';
  import italic from '@/assets/italic.svg';
  import strikethrough from '@/assets/strikethrough.svg';
  import left from '@/assets/left.svg';
  import center from '@/assets/center.svg';
  import right from '@/assets/right.svg';
  import horizontal from '@/assets/horizontal-center.svg';
  import verticalCenter from '@/assets/vertical-center.svg';
  import textLayerIcon from "@/assets/text.png";
  import InputDialog from "@/components/InputDialog.vue";
  import {LayersMaximum, MaterialType, PLATEN_WIDTH_CM, PLATEN_HEIGHT_CM, PLATEN_WIDTH_IN, PLATEN_HEIGHT_IN, BACK_COLLAR_WIDTH_CM, BACK_COLLAR_HEIGHT_CM, BACK_COLLAR_WIDTH_IN, BACK_COLLAR_HEIGHT_IN, CM_PER_INCH, BACK_COLLAR_FACE_ID, BACK_COLLAR_FRAME_DISPLAY} from '@/common/constants.js';
  import VueDraggable from 'vuedraggable';
  import _ from "lodash";
  import {readImageMeta, DEFAULT_PRINT_DPI} from '@/utils/imageMeta.js';
  import FontSelect from "@/components/FontSelect.vue";
  import {ElMessage, ElMessageBox} from "element-plus";
  import axios from "axios";
  import {deleteUserImage, finish, getClipartList, getFontList, getUserImages, init} from "@/api/api";
  import LayerIcon from "@/components/icons/LayerIcon.vue";
  import ImageIcon from "@/components/icons/ImageIcon.vue";
  import ClipartIcon from "@/components/icons/ClipartIcon.vue";
  import dayjs from "dayjs";
  // endregion

  // region 字段
  // 获取当前 URL 的查询参数
  const searchParams = new URLSearchParams(window.location.search);
  // 将参数转换为对象
  const urlParams = {}
  for (const [key, value] of searchParams.entries()) {
    urlParams[key] = value
  }
  // AES加密字符串
  let encrypt = urlParams.d ? decodeURIComponent(urlParams.d) : ""
  // 记录编辑器操作历史
  let editHistory = ref([]);
  // 当前历史记录索引
  let currentHistoryIndex = ref(-1);
  // 当前底图面的值
  const currentPosition = ref(1);

  // 当前选中的素材id
  const currentLayer = ref(0);
  // 字体列表
  const fontList = ref([]);
  // 字体大小
  const fontSize = ref(20);
  // 选中的字体
  const familyValue = ref({});
  // 字间距
  const letterSpacing = ref(0);
  // 行高
  const lineHeight = ref(1.5);
  // 字色
  const color = ref('');
  // 编辑器ref
  const imageEditorRef = ref(null);
  // 可选的字体颜色
  const fixedColor = [
    '#FFFFFF',
    '#000000',
    '#FF0000',
    '#00BAAD',
    '#AC33C1',
    '#808080',
    '#A5D63F',
    '#FFC300',
    '#2A82E4'
  ];
  // 文本对话框弹出状态
  const openInputDialog = ref(false);
  // 文本对话框的值
  const dialogText = ref("");
  // 是否更新文本
  const isTextUpdate = ref(false);
  // 提交报文
  const submitList = ref([]);
  // 编辑器数据模型
  const editorData = ref([]);
  // 当前可操作素材项
  const sourceMaterialList = ref([]);
  // 当前素材
  const sourceMaterialInfo = ref({});
  // 整页loading
  const containerLoading = ref(false);
  // 左侧激活中的选项卡
  const activeTab = ref(1);
  // 素材库搜索关键字
  const clipartSearchValue = ref('');
  // 素材库列表
  const clipartList = ref([]);
  // 文本值
  const inputValue = ref("");
  // 已保存的设计
  const savedDesignsList = ref([]);
  // 设计ID
  let designId = 0;
  // 素材库原始数据 用于搜索时留存
  let orignClipartList = [];
  // 上传进度相关
  const progressPercentage = ref(0)
  const uploading = ref(false)
  const uploadSpeed = ref('0 KB/s')
  const remainingTime = ref('--')
  let uploadStartTime = 0
  let lastLoaded = 0
  let lastTime = 0
  // 已保存的设计加载中状态
  const savedAreaLoading = ref(false);
  // 已保存的设计分页
  const savedPage = ref(1);
  const savedPageSize = ref(50);
  const savedPageSizeOptions = [20, 50, 100];
  // 已保存的设计虚拟滚动
  const savedAreaRef = ref(null);
  const savedScrollTop = ref(0);
  const savedViewportHeight = ref(600);
  const SAVED_ITEMS_PER_ROW = 2;
  const SAVED_ROW_HEIGHT = 282;
  const SAVED_OVERSCAN_ROWS = 2;
  let savedAreaResizeObserver = null;
  // 素材库加载中状态
  const clipartLoading = ref(false);
  // 字体加载中
  const fontLoading = ref(false);
  // Unit Price
  const unitPrice = ref(0);
  // 编辑器是否已回传过最新素材列表
  const submitListReady = ref(false);
  // Front/Back/Back Collar 至少有一个面存在设计素材时才允许 Finish
  const hasAnyDesign = computed(() => {
    const list = submitListReady.value ? submitList.value : editorData.value;
    return list.some(face => [1, 2, 3].includes(Number(face.id)) && face.materials?.length > 0);
  });
  // 底图正反面
  const positions = ref([]);
  // 页面是否可访问
  const allowAccess = ref(false);
  // 当前选中图层的打印尺寸（单位：英寸，保留2位小数；画布仍以厘米为准，仅展示换算为英寸）
  const printWidth = ref(0);
  const printHeight = ref(0);
  // 当前选中图层的打印位置（单位：英寸，距内部画框左/上边线内侧距离，保留2位小数）
  const printLeft = ref(0);
  const printTop = ref(0);
  // 标志位：用户正在手动修改打印尺寸/位置，防止 calculate 函数覆盖输入值
  let _printSizeUserEditing = false;
  // 锁定宽高比（默认开启）
  const lockAspectRatio = ref(true);
  // 记录每个素材的初始宽高，作为缩放百分比（100%）的基准（上传/添加时的原始尺寸）
  const materialInitSize = ref({});
  // endregion

  // region 外部操作编辑器
  /**
   * 计算当前选中图层的打印尺寸（单位：英寸）
   * 优先使用上传时按原图 DPI 记录的真实物理尺寸（initPhysicalWidthCm/HeightCm，单位 cm），
   * 换算成英寸后按当前缩放比例展示，使「Scale 100%」等于图片自身的物理打印尺寸；
   * 无该信息的素材（素材库/文本等）回退为台板像素换算。
   * 注意：画布（台板）物理尺寸仍以厘米为准（44×54cm），此处仅在展示层换算为英寸。
   * 当用户正在手动编辑打印尺寸时跳过，避免覆盖用户输入
   */
  const calculatePrintSize = () => {
    if (_printSizeUserEditing) return;
    const material = sourceMaterialInfo.value;
    if (!material || !material.width || !material.height) {
      printWidth.value = 0;
      printHeight.value = 0;
      return;
    }
    // 获取当前面的 frame 像素尺寸
    const currentFace = editorData.value.find(x => x.id == currentPosition.value) || editorData.value[0];
    if (!currentFace || !currentFace.frameWidth || !currentFace.frameHeight) {
      printWidth.value = 0;
      printHeight.value = 0;
      return;
    }
    // 台板物理尺寸换算为英寸后，得到每个像素对应的英寸数
    const physicalWidthIn  = currentFace.id == BACK_COLLAR_FACE_ID ? BACK_COLLAR_WIDTH_IN  : PLATEN_WIDTH_IN;
    const physicalHeightIn = currentFace.id == BACK_COLLAR_FACE_ID ? BACK_COLLAR_HEIGHT_IN : PLATEN_HEIGHT_IN;
    const inPerPixelX = physicalWidthIn  / currentFace.frameWidth;
    const inPerPixelY = physicalHeightIn / currentFace.frameHeight;

    const init = materialInitSize.value[material.id];
    const initWidth = init?.width || material.initWidth || material.width;
    const initHeight = init?.height || material.initHeight || material.height;
    // 真实物理尺寸以 cm 存储，展示前换算为英寸
    const physicalWidthCm = Number(material.initPhysicalWidthCm);
    const physicalHeightCm = Number(material.initPhysicalHeightCm);

    // 有真实物理尺寸：按缩放比例换算；否则按台板像素换算
    if (physicalWidthCm > 0 && initWidth > 0) {
      printWidth.value = parseFloat(((physicalWidthCm / CM_PER_INCH) * (material.width / initWidth)).toFixed(2));
    } else {
      printWidth.value = parseFloat((material.width * inPerPixelX).toFixed(2));
    }
    if (physicalHeightCm > 0 && initHeight > 0) {
      printHeight.value = parseFloat(((physicalHeightCm / CM_PER_INCH) * (material.height / initHeight)).toFixed(2));
    } else {
      printHeight.value = parseFloat((material.height * inPerPixelY).toFixed(2));
    }
  };

  /**
   * 计算当前选中图层的打印位置（单位：英寸）
   * Left = 图层左边缘距 frame 左边线内侧的距离
   * Top  = 图层上边缘距 frame 上边线内侧的距离
   * 坐标系：material.x / material.y 为图层左上角相对于 frame 左上角的像素偏移
   * 当用户正在手动编辑位置时跳过，避免覆盖用户输入
   */
  const calculatePrintPosition = () => {
    if (_printSizeUserEditing) return;
    const material = sourceMaterialInfo.value;
    if (!material || material.x == null || material.y == null) {
      printLeft.value = 0;
      printTop.value = 0;
      return;
    }
    const currentFace = editorData.value.find(x => x.id == currentPosition.value) || editorData.value[0];
    if (!currentFace || !currentFace.frameWidth || !currentFace.frameHeight) {
      printLeft.value = 0;
      printTop.value = 0;
      return;
    }
    const physicalWidthIn  = currentFace.id == BACK_COLLAR_FACE_ID ? BACK_COLLAR_WIDTH_IN  : PLATEN_WIDTH_IN;
    const physicalHeightIn = currentFace.id == BACK_COLLAR_FACE_ID ? BACK_COLLAR_HEIGHT_IN : PLATEN_HEIGHT_IN;
    const inPerPixelX = physicalWidthIn  / currentFace.frameWidth;
    const inPerPixelY = physicalHeightIn / currentFace.frameHeight;
    printLeft.value = parseFloat((material.x * inPerPixelX).toFixed(2));
    printTop.value = parseFloat((material.y * inPerPixelY).toFixed(2));
  };

  /**
   * 记录素材的初始宽高，作为缩放百分比（100%）的基准。
   * 仅首次记录，后续尺寸变化不再覆盖，保证 100% 始终对应上传/添加时的原始尺寸。
   * @param {Object} material 素材对象
   */
  const _rememberMaterialInitSize = (material) => {
    if (!material || material.id == null) return;
    if (materialInitSize.value[material.id]) return;
    // 优先使用素材自身的 initWidth/initHeight（上传/添加时的原始尺寸）
    const initWidth = material.initWidth || material.width;
    const initHeight = material.initHeight || material.height;
    if (!initWidth || !initHeight) return;
    materialInitSize.value[material.id] = { width: initWidth, height: initHeight };
  };

  /**
   * 依据原图像素与 DPI 计算其在设计区（frame）中应占的像素尺寸，以及图片自身的真实物理尺寸。
   * 物理尺寸（cm）= 像素 / DPI × 2.54；再按台板物理尺寸换算成 frame 像素。
   * 画布像素取整（编辑器内部按整数像素处理），真实物理尺寸单独返回用于打印尺寸展示。
   * @param {number} origWidth 原图像素宽
   * @param {number} origHeight 原图像素高
   * @param {number} dpiX 水平方向 DPI
   * @param {number} dpiY 垂直方向 DPI
   * @param {Object} [face] 目标面，缺省取当前面
   * @returns {{width:number, height:number, cmWidth:number, cmHeight:number}|null}
   */
  const _calcFrameSizeByDpi = (origWidth, origHeight, dpiX, dpiY, face) => {
    const targetFace = face || editorData.value.find(x => x.id == currentPosition.value) || editorData.value[0];
    if (!targetFace?.frameWidth || !targetFace?.frameHeight) return null;
    const isBackCollar = targetFace.id == BACK_COLLAR_FACE_ID;
    const physicalWidth  = isBackCollar ? BACK_COLLAR_WIDTH_CM  : PLATEN_WIDTH_CM;
    const physicalHeight = isBackCollar ? BACK_COLLAR_HEIGHT_CM : PLATEN_HEIGHT_CM;
    const dpiXVal = dpiX > 0 ? dpiX : DEFAULT_PRINT_DPI;
    const dpiYVal = dpiY > 0 ? dpiY : DEFAULT_PRINT_DPI;
    const cmWidth  = (origWidth  / dpiXVal) * CM_PER_INCH;
    const cmHeight = (origHeight / dpiYVal) * CM_PER_INCH;
    return {
      width:  Math.max(1, Math.round((cmWidth  / physicalWidth)  * targetFace.frameWidth)),
      height: Math.max(1, Math.round((cmHeight / physicalHeight) * targetFace.frameHeight)),
      cmWidth,
      cmHeight,
    };
  };

  /**
   * 依据 DPI 将原图按真实物理尺寸加入编辑器（画布仍使用缩略图 URL）。
   * 真实物理尺寸（initPhysicalWidthCm/initPhysicalHeightCm）写入素材，
   * 供 calculatePrintSize 在「Scale 100%」时精确展示，避免整数像素取整带来的误差。
   * 读取不到原图信息时回退为按缩略图尺寸落位。
   * @param {File} file 原始上传文件
   * @param {string} thumbPath 后端返回的缩略图相对路径
   * @param {string} id 素材 id
   */
  const _addImageByDpi = async (file, thumbPath, id) => {
    const materialUrl = `/Images/${thumbPath}`;
    try {
      const meta = await readImageMeta(file);
      const size = _calcFrameSizeByDpi(meta.width, meta.height, meta.dpiX, meta.dpiY);
      if (size) {
        imageEditorRef["value"].addImage({
          materialUrl,
          id,
          width: size.width,
          height: size.height,
          initPhysicalWidthCm: size.cmWidth,
          initPhysicalHeightCm: size.cmHeight,
        });
        return;
      }
    } catch (e) {
      console.error('读取原图 DPI/尺寸失败，回退为缩略图尺寸：', e);
    }
    // 兜底：沿用缩略图尺寸
    await _addImageByThumbnail(thumbPath, id);
  };

  /**
   * 兜底：按缩略图自身尺寸将图片加入编辑器
   * @param {string} thumbPath 缩略图相对路径
   * @param {string} id 素材 id
   */
  const _addImageByThumbnail = (thumbPath, id) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const materialUrl = `/Images/${thumbPath}`;
        if (currentPosition.value === BACK_COLLAR_FACE_ID) {
          const size = calculateThumbnailSize(img.width, img.height, 160);
          imageEditorRef["value"].addImage({ materialUrl, id, width: size.width, height: size.height });
        } else {
          imageEditorRef["value"].addImage({ materialUrl, id, width: img.width, height: img.height });
        }
        resolve();
      };
      img.onerror = () => resolve();
      img.src = `/Images/${thumbPath}`;
    });
  };

  /** 当前图片图层的旋转角度（单位：deg） */
  const rotateDeg = ref(0);
  /** 当前图片图层的缩放百分比（单位：%），100% 为素材原始尺寸 */
  const scalePercent = ref(100);
  // 标志位：用户正在手动修改旋转/缩放，防止 calculate 函数覆盖输入值
  let _transformUserEditing = false;

  /**
   * 计算当前图片图层的旋转角度与缩放百分比
   * 缩放百分比 = 当前宽度 / 原始宽度 × 100，100% 对应上传/添加时的原始尺寸
   * 当用户正在手动编辑时跳过，避免覆盖用户输入
   */
  const calculateTransform = () => {
    if (_transformUserEditing) return;
    const material = sourceMaterialInfo.value;
    if (!material || material.materialType !== MaterialType.Image) {
      rotateDeg.value = 0;
      scalePercent.value = 100;
      return;
    }
    const deg = Number(material.angle ?? material.rotation ?? 0);
    rotateDeg.value = isNaN(deg) ? 0 : parseFloat(deg.toFixed(2));
    const init = materialInitSize.value[material.id];
    const initWidth = init?.width || material.initWidth || material.width;
    scalePercent.value = initWidth && material.width
        ? parseFloat(((material.width / initWidth) * 100).toFixed(2))
        : 100;
  };

  /**
   * 将目标图层的 zIndex 提升为当前最大值，确保 setMaterials 后 $activeMaterial 自动选中它。
   * 这与 selectMaterial 内部调用 toTop 的行为一致，避免 cancel() 导致的选中状态闪失。
   * @param {Array} materials 克隆后的素材列表
   * @param {number} targetIndex 目标图层在数组中的下标
   */
  const _ensureTopZIndex = (materials, targetIndex) => {
    const maxZ = Math.max(...materials.map(m => m.zIndex || 0));
    const target = materials[targetIndex];
    if ((target.zIndex || 0) < maxZ) {
      // 找到当前持有 maxZ 的图层，将其 zIndex 与目标互换
      const topItem = materials.find(m => m.zIndex === maxZ);
      if (topItem) topItem.zIndex = target.zIndex || 0;
      target.zIndex = maxZ;
    }
  };

  /**
   * 将图片图层的 fillMode 和 editSize 写入 materials 数据，
   * 库（leafer-image-editor >= 0.0.8-beta.6）会在 addElement 时读取这两个字段：
   *   - fillMode: 'stretch' 使图像按新尺寸拉伸而非保持比例
   *   - editSize: 'size'|'font-size' 控制拖拽缩放时是否锁定宽高比
   * @param {Array} materials 克隆后的素材列表
   * @param {number} targetIndex 目标图层在数组中的下标
   */
  const _applyImageOptions = (materials, targetIndex) => {
    const m = materials[targetIndex];
    if (m.materialType !== 1) return; // 仅对图片图层生效
    m.fillMode = 'stretch';
    m.editSize = lockAspectRatio.value ? 'font-size' : 'size';
  };

  /**
   * Switch 切换锁定比例时，通过 setMaterials 将 editSize 同步到当前选中图层
   */
  const handleLockAspectRatioChange = (val) => {
    const liveFace = imageEditorRef["value"]?.getCurrentData();
    if (!liveFace || !liveFace.materials) return;
    const layerIndex = liveFace.materials.findIndex(m => m.id === currentLayer.value);
    if (layerIndex === -1) return;
    if (liveFace.materials[layerIndex].materialType !== 1) return; // 仅图片图层
    const updatedMaterials = _.cloneDeep(liveFace.materials);
    updatedMaterials[layerIndex].editSize = val ? 'font-size' : 'size';
    _ensureTopZIndex(updatedMaterials, layerIndex);
    imageEditorRef["value"].setMaterials(liveFace.id, updatedMaterials);
  };

  /**
   * 用户修改打印宽度（英寸）时，同步缩放图层。
   * 若 lockAspectRatio 为 true，按原始宽高比自动计算新高度并联动更新。
   * 注意：面板以英寸录入，最终换算为画布像素写入素材；后端依据画布像素渲染，与录入单位无关。
   * @param {string|number} inches 新的打印宽度（英寸）
   */
  const handleChangePrintWidth = (inches) => {
    const inVal = parseFloat(inches);
    if (!inVal || inVal <= 0) return;
    // frameWidth/frameHeight 在 init 时固定，从 editorData 读取即可
    const initFace = editorData.value.find(x => x.id == currentPosition.value) || editorData.value[0];
    if (!initFace || !initFace.frameWidth || !initFace.frameHeight) return;
    const physicalWidthIn  = initFace.id == BACK_COLLAR_FACE_ID ? BACK_COLLAR_WIDTH_IN  : PLATEN_WIDTH_IN;
    const physicalHeightIn = initFace.id == BACK_COLLAR_FACE_ID ? BACK_COLLAR_HEIGHT_IN : PLATEN_HEIGHT_IN;
    const inPerPixelX = physicalWidthIn  / initFace.frameWidth;
    const inPerPixelY = physicalHeightIn / initFace.frameHeight;
    const newPixelWidth = Math.round(inVal / inPerPixelX);
    // 从编辑器获取当前实时数据（包含用户拖拽/缩放后的最新状态）
    const liveFace = imageEditorRef["value"]?.getCurrentData();
    if (!liveFace || !liveFace.materials) return;
    const layerIndex = liveFace.materials.findIndex(m => m.id === currentLayer.value);
    if (layerIndex === -1) return;
    const targetMaterial = liveFace.materials[layerIndex];
    // 锁定比例时，按原始宽高比计算新高度
    let newPixelHeight = targetMaterial.height;
    let newInHeight = printHeight.value;
    if (lockAspectRatio.value && targetMaterial.width > 0) {
      const ratio = targetMaterial.height / targetMaterial.width;
      newPixelHeight = Math.round(newPixelWidth * ratio);
      newInHeight = parseFloat((newPixelHeight * inPerPixelY).toFixed(2));
    }
    // 克隆当前素材列表，修改目标图层的宽度（及联动高度），写入 fillMode/editSize，并确保其 zIndex 最高
    const updatedMaterials = _.cloneDeep(liveFace.materials);
    updatedMaterials[layerIndex].width = newPixelWidth;
    if (lockAspectRatio.value) updatedMaterials[layerIndex].height = newPixelHeight;
    _applyImageOptions(updatedMaterials, layerIndex);
    _ensureTopZIndex(updatedMaterials, layerIndex);
    // 设置标志位，防止 setMaterials 触发的 calculatePrintSize 覆盖用户输入的值
    _printSizeUserEditing = true;
    imageEditorRef["value"].setMaterials(liveFace.id, updatedMaterials);
    nextTick(() => {
      printWidth.value = inVal;
      if (lockAspectRatio.value) printHeight.value = newInHeight;
      _printSizeUserEditing = false;
    });
  };

  /**
   * 用户修改打印高度（英寸）时，同步缩放图层。
   * 若 lockAspectRatio 为 true，按原始宽高比自动计算新宽度并联动更新。
   * @param {string|number} inches 新的打印高度（英寸）
   */
  const handleChangePrintHeight = (inches) => {
    const inVal = parseFloat(inches);
    if (!inVal || inVal <= 0) return;
    // frameWidth/frameHeight 在 init 时固定，从 editorData 读取即可
    const initFace = editorData.value.find(x => x.id == currentPosition.value) || editorData.value[0];
    if (!initFace || !initFace.frameWidth || !initFace.frameHeight) return;
    const physicalWidthIn  = initFace.id == BACK_COLLAR_FACE_ID ? BACK_COLLAR_WIDTH_IN  : PLATEN_WIDTH_IN;
    const physicalHeightIn = initFace.id == BACK_COLLAR_FACE_ID ? BACK_COLLAR_HEIGHT_IN : PLATEN_HEIGHT_IN;
    const inPerPixelX = physicalWidthIn  / initFace.frameWidth;
    const inPerPixelY = physicalHeightIn / initFace.frameHeight;
    const newPixelHeight = Math.round(inVal / inPerPixelY);
    // 从编辑器获取当前实时数据（包含用户拖拽/缩放后的最新状态）
    const liveFace = imageEditorRef["value"]?.getCurrentData();
    if (!liveFace || !liveFace.materials) return;
    const layerIndex = liveFace.materials.findIndex(m => m.id === currentLayer.value);
    if (layerIndex === -1) return;
    const targetMaterial = liveFace.materials[layerIndex];
    // 锁定比例时，按原始宽高比计算新宽度
    let newPixelWidth = targetMaterial.width;
    let newInWidth = printWidth.value;
    if (lockAspectRatio.value && targetMaterial.height > 0) {
      const ratio = targetMaterial.width / targetMaterial.height;
      newPixelWidth = Math.round(newPixelHeight * ratio);
      newInWidth = parseFloat((newPixelWidth * inPerPixelX).toFixed(2));
    }
    // 克隆当前素材列表，修改目标图层的高度（及联动宽度），写入 fillMode/editSize，并确保其 zIndex 最高
    const updatedMaterials = _.cloneDeep(liveFace.materials);
    updatedMaterials[layerIndex].height = newPixelHeight;
    if (lockAspectRatio.value) updatedMaterials[layerIndex].width = newPixelWidth;
    _applyImageOptions(updatedMaterials, layerIndex);
    _ensureTopZIndex(updatedMaterials, layerIndex);
    // 设置标志位，防止 setMaterials 触发的 calculatePrintSize 覆盖用户输入的值
    _printSizeUserEditing = true;
    imageEditorRef["value"].setMaterials(liveFace.id, updatedMaterials);
    nextTick(() => {
      printHeight.value = inVal;
      if (lockAspectRatio.value) printWidth.value = newInWidth;
      _printSizeUserEditing = false;
    });
  };

  /**
   * 用户修改打印 Left（英寸）时，同步移动图层的 x 坐标。
   * @param {string|number} inches 新的 Left 值（英寸）
   */
  const handleChangePrintLeft = (inches) => {
    const inVal = parseFloat(inches);
    if (inVal == null || isNaN(inVal) || inVal < 0) return;
    const initFace = editorData.value.find(x => x.id == currentPosition.value) || editorData.value[0];
    if (!initFace || !initFace.frameWidth) return;
    const physicalWidthIn = initFace.id == BACK_COLLAR_FACE_ID ? BACK_COLLAR_WIDTH_IN : PLATEN_WIDTH_IN;
    const inPerPixelX = physicalWidthIn / initFace.frameWidth;
    const newPixelX = Math.round(inVal / inPerPixelX);
    const liveFace = imageEditorRef["value"]?.getCurrentData();
    if (!liveFace || !liveFace.materials) return;
    const layerIndex = liveFace.materials.findIndex(m => m.id === currentLayer.value);
    if (layerIndex === -1) return;
    const updatedMaterials = _.cloneDeep(liveFace.materials);
    updatedMaterials[layerIndex].x = newPixelX;
    _applyImageOptions(updatedMaterials, layerIndex);
    _ensureTopZIndex(updatedMaterials, layerIndex);
    _printSizeUserEditing = true;
    imageEditorRef["value"].setMaterials(liveFace.id, updatedMaterials);
    nextTick(() => {
      printLeft.value = inVal;
      _printSizeUserEditing = false;
    });
  };

  /**
   * 用户修改打印 Top（英寸）时，同步移动图层的 y 坐标。
   * @param {string|number} inches 新的 Top 值（英寸）
   */
  const handleChangePrintTop = (inches) => {
    const inVal = parseFloat(inches);
    if (inVal == null || isNaN(inVal) || inVal < 0) return;
    const initFace = editorData.value.find(x => x.id == currentPosition.value) || editorData.value[0];
    if (!initFace || !initFace.frameHeight) return;
    const physicalHeightIn = initFace.id == BACK_COLLAR_FACE_ID ? BACK_COLLAR_HEIGHT_IN : PLATEN_HEIGHT_IN;
    const inPerPixelY = physicalHeightIn / initFace.frameHeight;
    const newPixelY = Math.round(inVal / inPerPixelY);
    const liveFace = imageEditorRef["value"]?.getCurrentData();
    if (!liveFace || !liveFace.materials) return;
    const layerIndex = liveFace.materials.findIndex(m => m.id === currentLayer.value);
    if (layerIndex === -1) return;
    const updatedMaterials = _.cloneDeep(liveFace.materials);
    updatedMaterials[layerIndex].y = newPixelY;
    _applyImageOptions(updatedMaterials, layerIndex);
    _ensureTopZIndex(updatedMaterials, layerIndex);
    _printSizeUserEditing = true;
    imageEditorRef["value"].setMaterials(liveFace.id, updatedMaterials);
    nextTick(() => {
      printTop.value = inVal;
      _printSizeUserEditing = false;
    });
  };

  /**
   * 用户修改旋转角度（deg）时，同步旋转图层。
   * angle 为绝对角度，通过 setMaterials 写入，保证与画布上拖拽旋转的结果一致。
   * @param {string|number} deg 新的旋转角度（deg）
   */
  const handleChangeRotate = (deg) => {
    const degVal = parseFloat(deg);
    if (isNaN(degVal)) {
      // 输入非法时恢复为图层当前角度
      calculateTransform();
      return;
    }
    const liveFace = imageEditorRef["value"]?.getCurrentData();
    if (!liveFace || !liveFace.materials) return;
    const layerIndex = liveFace.materials.findIndex(m => m.id === currentLayer.value);
    if (layerIndex === -1) return;
    if (liveFace.materials[layerIndex].materialType !== MaterialType.Image) return; // 仅图片图层
    const updatedMaterials = _.cloneDeep(liveFace.materials);
    updatedMaterials[layerIndex].angle = degVal;
    _applyImageOptions(updatedMaterials, layerIndex);
    _ensureTopZIndex(updatedMaterials, layerIndex);
    // 设置标志位，防止 setMaterials 触发的 calculateTransform 覆盖用户输入的值
    _transformUserEditing = true;
    imageEditorRef["value"].setMaterials(liveFace.id, updatedMaterials);
    nextTick(() => {
      rotateDeg.value = degVal;
      _transformUserEditing = false;
    });
  };

  /**
   * 用户修改缩放百分比（%）时，以素材原始尺寸为基准等比缩放图层。
   * @param {string|number} percent 新的缩放百分比（%）
   */
  const handleChangeScale = (percent) => {
    const percentVal = parseFloat(percent);
    if (isNaN(percentVal) || percentVal <= 0) {
      // 输入非法时恢复为图层当前缩放比例
      calculateTransform();
      return;
    }
    const liveFace = imageEditorRef["value"]?.getCurrentData();
    if (!liveFace || !liveFace.materials) return;
    const layerIndex = liveFace.materials.findIndex(m => m.id === currentLayer.value);
    if (layerIndex === -1) return;
    const targetMaterial = liveFace.materials[layerIndex];
    if (targetMaterial.materialType !== MaterialType.Image) return; // 仅图片图层
    const init = materialInitSize.value[targetMaterial.id];
    const initWidth = init?.width || targetMaterial.initWidth || targetMaterial.width;
    const initHeight = init?.height || targetMaterial.initHeight || targetMaterial.height;
    if (!initWidth || !initHeight) return;
    const updatedMaterials = _.cloneDeep(liveFace.materials);
    updatedMaterials[layerIndex].width = Math.round(initWidth * percentVal / 100);
    updatedMaterials[layerIndex].height = Math.round(initHeight * percentVal / 100);
    _applyImageOptions(updatedMaterials, layerIndex);
    _ensureTopZIndex(updatedMaterials, layerIndex);
    // 设置标志位，防止 setMaterials 触发的 calculateTransform 覆盖用户输入的值
    _transformUserEditing = true;
    imageEditorRef["value"].setMaterials(liveFace.id, updatedMaterials);
    nextTick(() => {
      scalePercent.value = percentVal;
      _transformUserEditing = false;
    });
  };

  /**
   * 将当前选中（最上层）素材在所属面的加工区内水平垂直居中。
   * 库的 addImage 内部会覆盖传入的 x/y，需在添加完成后通过 setMaterials 重新写入居中坐标。
   */
  const _centerActiveMaterialInFrame = () => {
    const liveFace = imageEditorRef["value"]?.getCurrentData();
    if (!liveFace || !liveFace.materials?.length) return;
    const initFace = editorData.value.find(x => x.id == currentPosition.value) || editorData.value[0];
    if (!initFace || !initFace.frameWidth || !initFace.frameHeight) return;
    const maxZ = Math.max(...liveFace.materials.map(m => m.zIndex || 0));
    const layerIndex = liveFace.materials.findIndex(m => (m.zIndex || 0) === maxZ);
    if (layerIndex === -1) return;
    const targetMaterial = liveFace.materials[layerIndex];
    if (!targetMaterial.width || !targetMaterial.height) return;
    const updatedMaterials = _.cloneDeep(liveFace.materials);
    updatedMaterials[layerIndex].x = Math.round((initFace.frameWidth - targetMaterial.width) / 2);
    updatedMaterials[layerIndex].y = Math.round((initFace.frameHeight - targetMaterial.height) / 2);
    _ensureTopZIndex(updatedMaterials, layerIndex);
    imageEditorRef["value"].setMaterials(liveFace.id, updatedMaterials);
  };

  /**
   * 拖拽图层顺序
   * @param data
   */
  const onDragEnd = (data) => {
    imageEditorRef["value"].sortMaterial(data["oldIndex"], data["newIndex"], true);
  }

  /**
   * on click layer item
   * @param id item id
   */
  const onClickLayerItem = (id) => {
    // 如果点击的是当前选中的图层，则return。（不return的话，选中的素材效果会消失）
    if (currentLayer.value === id) return;
    currentLayer.value = id;
    imageEditorRef["value"].selectMaterial(id);
  }

  /**
   * 弹出文本对话框
   */
  const onOpenTextDialog = () => {
    dialogText.value = '';
    isTextUpdate.value = false;
    openInputDialog.value = true;
  }

  /** 文本对话框提交文本 */
  const onInputDialogSubmit = (value) => {
    if (isTextUpdate.value) {
      imageEditorRef["value"].replaceText(value);
    } else {
      imageEditorRef["value"].addText({ content: value, id: Date.now().toString() });
      if (currentPosition.value === BACK_COLLAR_FACE_ID) {
        nextTick(() => _fitTextToBackCollar());
      }
    }
  };
  // endregion

  // region 编辑器方法与事件
  /**
   * 添加素材超出限制
   */
  const onExceedsLimit = () => {
    ElMessage.warning("The number of materials exceeds the limit.");
  }

  /** 更换字体  */
  const handleChangeFamily = (e) => {
    imageEditorRef["value"]["textStyles"]?.family({
      fontFamily: e.family,
      fontFamilyUrl: e.url
    });
    familyValue.value = e;
  };

  /** 字色 */
  const handleChangeColor = (value) => {
    imageEditorRef["value"]["textStyles"]?.color(value);
  };

  /**
   * 编辑素材（双击文字图层时触发）
   * 切换到 Layers 选项卡并进入文字内容编辑状态
   * @param record 当前素材记录
   */
  const handleMaterialEdit = (record) => {
    if (record.materialType === MaterialType.Text) {
      activeTab.value = 3;
      isTextUpdate.value = true;
      inputValue.value = record.text;
    }
  }

  /**
   * 在 Layers 面板中点击 Edit 按钮，进入文字内容编辑状态
   */
  const onStartEditText = () => {
    const material = sourceMaterialInfo.value;
    if (!material || material.materialType !== MaterialType.Text) return;
    inputValue.value = material.content || material.text || '';
    isTextUpdate.value = true;
  };

  /**
   * 取消文字内容编辑，恢复初始状态
   */
  const onCancelEditText = () => {
    isTextUpdate.value = false;
    inputValue.value = '';
  };

  /**
   * 删除当前面的某个素材
   * @param id 素材Id
   */
  const handleDeleteLayer = (id) => {
    imageEditorRef["value"].removeMaterial(id);
  }

  /** 垂直居中 */
  const handleVerticalCenter = () => imageEditorRef["value"].verticalCenter();

  /** 水平居中 */
  const handleHorizontalCenter = () => imageEditorRef["value"].horizontalCenter();

  /** 字号 */
  const handleChangeSize = (e) => imageEditorRef["value"]["textStyles"]?.fontSize(e);

  /** 加粗 */
  const handleChangeBold = () => {
    if (sourceMaterialInfo.value.fontWeight === 'bold') {
      imageEditorRef["value"]["textStyles"]?.bold(true);
      return;
    }
    imageEditorRef["value"]["textStyles"]?.bold();
  };

  /** 下划线 */
  const handleChangeUnderLine = () => {
    if (sourceMaterialInfo.value.textDecoration === 'underline') {
      imageEditorRef["value"]["textStyles"]?.underLine(true);
      return;
    }
    imageEditorRef["value"]["textStyles"]?.underLine();
  };

  /** 斜体 */
  const handleChangeItalic = () => {
    if (sourceMaterialInfo.value.fontStyle === 'italic') {
      imageEditorRef["value"]["textStyles"]?.italic(true);
      return;
    }
    imageEditorRef["value"]["textStyles"]?.italic();
  };

  /** 删除线 */
  const handleChangeLineThrough = () => {
    if (sourceMaterialInfo.value.textDecoration === 'line-through') {
      imageEditorRef["value"]["textStyles"]?.lineThrough(true);
      return;
    }
    imageEditorRef["value"]["textStyles"]?.lineThrough();
  };

  /** 文字居左 */
  const handleChangeAlignLeft = () =>
      imageEditorRef["value"]["textStyles"]?.alignLeft();

  /** 文字居中 */
  const handleChangeAlignCenter = () => {
    if (sourceMaterialInfo.value.textAlign === 'center') {
      imageEditorRef["value"]["textStyles"]?.alignLeft();
      return;
    }
    imageEditorRef["value"]["textStyles"]?.alignCenter();
  };

  /** 文字居右 */
  const handleChangeAlignRight = () => {
    if (sourceMaterialInfo.value.textAlign === 'right') {
      imageEditorRef["value"]["textStyles"]?.alignLeft();
      return;
    }
    imageEditorRef["value"]["textStyles"]?.alignRight();
  };

  /** 文字间距 */
  const handleChangeLetterSpacing = (value) =>
      imageEditorRef["value"]["textStyles"]?.letterSpacing(value);

  /** 文字行高 */
  const handleChangeLineHeight = (value) =>
      imageEditorRef["value"]["textStyles"]?.lineHeight(value);

  /**
   * 复制
   */
  const handleCopy = () => {
    imageEditorRef["value"].copy();
  }

  /**
   * 双击文本素材 同文本类图层编辑
   * @param record 当前素材记录
   */
  const onDoubleClickText = (record) => {
    handleMaterialEdit(record);
  }

  /**
   * 编辑器change
   * @param position
   * @param list
   */
  const handleEditorChange = (position, list) => {
    submitList.value = list;
    submitListReady.value = true;
    // 当前素材项
    sourceMaterialInfo.value = imageEditorRef["value"]?.getActiveData();
    // 当前素材面
    sourceMaterialList.value = imageEditorRef["value"]?.getCurrentData()?.["materials"];
    // 当前面没有素材时清空选中状态，避免详情面板残留
    if (!sourceMaterialList.value?.length) {
      currentLayer.value = 0;
      sourceMaterialInfo.value = {};
    }
    // 更新打印尺寸显示
    calculatePrintSize();
    calculatePrintPosition();
    calculateTransform();
    // 20260109新增
    // 判断正面和背面是否都有素材，两面都有时才加背面的价格（单面打印价格相同，多一面才加价）
    const frontFace = list.find(x => x.id == 1) || list[0];
    const backFace = list.find(x => x.id == 2) || list[1];
    const backCollarFace = list.find(x => x.id == 3);
    let total = Number(frontFace["price"]);
    if (frontFace?.["materials"]?.length > 0 && backFace?.["materials"]?.length > 0)
      total += Number(backFace["price"]);
    if (backCollarFace?.["materials"]?.length > 0)
      total += Number(backCollarFace["price"]);
    unitPrice.value = total.toFixed(2);
  };

  /**
   * 编辑器操作回调
   * @param list 新返回的list
   * @param type 动作类型
   */
  const onOperation = (list, type) => {
    // 选中图层后，切换到 Layers 选项卡，在列表下方显示对应操作内容
    if (type === "select") {
      activeTab.value = 3;
    }
    // 同步layers列表的选中状态
    if (["select", "delete", "add"].includes(type))
      currentLayer.value = imageEditorRef["value"]?.getActiveData().id;
    // 选中图层时，将当前 lockAspectRatio 状态同步到图层的 editSize（控制画布拖拽缩放比例）
    if (type === "select") {
      nextTick(() => handleLockAspectRatioChange(lockAspectRatio.value));
    }
    // 更新打印尺寸显示（选中、缩放、旋转等操作后同步）
    calculatePrintSize();
    calculatePrintPosition();
    calculateTransform();
    let editHistoryValue = _.cloneDeep(editHistory.value);
    // 判断当前操作索引 如果不是最后一个 则删除当前索引后的所有项
    if (currentHistoryIndex.value !== editHistoryValue.length - 1) {
      editHistoryValue.splice(currentHistoryIndex.value);
    }
    editHistoryValue.push(list);
    editHistory.value = editHistoryValue;
    currentHistoryIndex.value = editHistoryValue.length - 1;
  }

  /**
   * 撤回操作
   */
  const onUndo = () => {
    imageEditorRef["value"].reset(editHistory.value[currentHistoryIndex.value - 1]);
    currentHistoryIndex.value = currentHistoryIndex.value - 1;
  }

  /**
   * 恢复操作
   */
  const onRedo = () => {
    imageEditorRef["value"].reset(editHistory.value[currentHistoryIndex.value + 1]);
    currentHistoryIndex.value = currentHistoryIndex.value + 1;
  }
  // endregion

  // region 上传
  // 上传前的校验
  const beforeUpload = (file) => {
    const isPNG = file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < 200;
    if (!isPNG) {
      ElMessage.warning('Only PNG format images are supported!');
      return false;
    }
    if (!isLt2M) {
      ElMessage.warning('Image size cannot exceed 200MB!');
      return false;
    }
    return true;
  };

  // 自定义上传方法
  const httpRequest = async (options) => {
    const {file, onProgress, onSuccess, onError} = options;
    uploading.value = true
    progressPercentage.value = 0
    uploadStartTime = Date.now()
    lastLoaded = 0
    lastTime = uploadStartTime

    try {
      // 创建FormData对象
      const formData = new FormData();
      formData.append('file', file);

      // 设置 query 参数
      const queryParams = {
        designId,
        width: 200
      };

      // 调用上传接口
      const rst = await axios.post('/api/design/upload', formData, {
        params: queryParams,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.lengthComputable) {
            progressPercentage.value = Math.round((progressEvent.loaded / progressEvent.total) * 100)

            // 计算上传速度
            const currentTime = Date.now()
            const timeDiff = (currentTime - lastTime) / 1000 // 秒
            const loadedDiff = progressEvent.loaded - lastLoaded

            if (timeDiff > 0) {
              const speed = loadedDiff / timeDiff / 1024 // KB/s
              uploadSpeed.value = speed > 1024
                  ? `${(speed / 1024).toFixed(1)} MB/s`
                  : `${speed.toFixed(1)} KB/s`

              // 计算剩余时间
              const remainingBytes = progressEvent.total - progressEvent.loaded
              const remainingSec = remainingBytes / (speed * 1024)
              if (remainingSec > 3600) {
                remainingTime.value = `${(remainingSec / 3600).toFixed(1)}h`
              } else if (remainingSec > 60) {
                remainingTime.value = `${(remainingSec / 60).toFixed(1)}m`
              } else {
                remainingTime.value = `${Math.ceil(remainingSec)}s`
              }
            }

            lastLoaded = progressEvent.loaded
            lastTime = currentTime

            // 调用 onProgress
            if (onProgress) {
              onProgress(progressEvent)
            }
          }
        }
      });
      // 上传成功处理
      if (rst.data.code === 0) {
        onSuccess(rst.data.data);
        // 按原图的像素尺寸与 DPI 换算出真实物理尺寸后落位（画布仍用缩略图，不加载原图）
        await _addImageByDpi(file, rst.data.data, file.uid);
        // 新上传的图片默认放置在设计区中间
        nextTick(() => _centerActiveMaterialInFrame());
        uploading.value = false
        ElMessage.success('upload success')
      } else {
        uploading.value = false
        onError(new Error(rst.data.msg));
        ElMessage.error(`upload fail:${rst.data.msg}`);
      }
    } catch (error) {
      uploading.value = false
      onError(error);
      ElMessage.error('Upload failed');
    }
  };
  // endregion ====================上传相关====================

  // region 加载字体 - 高级优化版本
  // 查询字体列表
  const getFonts = async (id) => {
    fontLoading.value = true;
    try {
      const rst = await getFontList(id);
      if (rst.code !== 0) {
        fontLoading.value = false;
        ElMessage.error(`Failed to get font：${rst.msg}`);
        return;
      }
      const rstData = rst.data;
      // 显示字体加载进度
      const totalFonts = rstData.length;
      let loadedCount = 0;
      // 使用分批并行加载，避免一次性创建太多请求
      const maxConcurrency = 10; // 最大并发数
      const results = [];
      for (let i = 0; i < rstData.length; i += maxConcurrency) {
        const batch = rstData.slice(i, i + maxConcurrency);
        const batchPromises = batch.map(async (font) => {
          try {
            await loadFont(font["family"], font["url"]);
            loadedCount++;
            // 可以在这里更新加载进度
            // console.log(`Loading fonts: ${loadedCount}/${totalFonts}`);
            return font;
          } catch (error) {
            console.warn(`Failed to load font ${font.name}:`, error);
            fontLoading.value = false;
            return null; // 返回 null 表示加载失败
          }
        });
        const batchResults = await Promise.allSettled(batchPromises);
        // 过滤成功加载的字体
        const successfulFonts = batchResults
            .filter(result => result.status === 'fulfilled' && result.value !== null)
            .map(result => result.value);
        results.push(...successfulFonts);
      }
      fontList.value = results.map((x) => ({
        ...x,
        label: x.name,
        value: x.id,
      }));
      console.log(`Successfully loaded ${results.length} fonts out of ${totalFonts}`);
    } catch (err) {
      fontLoading.value = false;
      console.error('Error to get font:', err);
    }
  };
  /**
   * 页面挂载字体文件（带超时控制）
   * @param fontName font family
   * @param fontUrl font url
   * @returns {Promise<void>}
   */
  const loadFont = (fontName, fontUrl) => {
    return new Promise((resolve, reject) => {
      // 设置字体加载超时时间
      const timeout = setTimeout(() => {
        reject(new Error(`Font load timeout: ${fontName}`));
      }, 1000 * 60); // 60s超时
      try {
        const font = new FontFace(fontName, `url(${fontUrl})`);
        font.load().then(() => {
          clearTimeout(timeout);
          document.fonts.add(font);
          resolve();
        }).catch((error) => {
          clearTimeout(timeout);
          reject(error);
        });
      } catch (error) {
        clearTimeout(timeout);
        reject(error);
      }
    });
  };
  // endregion

  /**
   * Init
   * @returns {Promise<void>}
   */
  const editorInit = async () => {
    try {
      const rst = await init({encrypt});
      if (rst.code !== 0) {
        ElMessage.error(`Failed to init：${rst.msg}`);
        return;
      }
      const editorList = rst.data["editorJson"]["editorList"];
      designId = rst.data["editorJson"]["designId"];
      // 默认设置44:54比例的编辑区（44cm×54cm台板）
      editorList.forEach(x => {
        x.frameX = 162;
        x.frameY = 130;
        x.frameWidth = 273;
        x.frameHeight = 335;
      })
      // Front 单独调整 frameY
      if (editorList[0]) {
        editorList[0].frameY = 90;
      }
      // Back 单独调整 frameY
      if (editorList[1]) {
        editorList[1].frameY = 90;
      }
      // Back Collar：固定 4×4 英寸（10.16×10.16 cm），前端放大至 300×300px，领下居中
      const backCollarFace = editorList.find(x => x.id == 3) || null;
      if (backCollarFace) {
        backCollarFace.frameX = 130;
        backCollarFace.frameY = 180;
        backCollarFace.frameWidth = BACK_COLLAR_FRAME_DISPLAY;
        backCollarFace.frameHeight = BACK_COLLAR_FRAME_DISPLAY;
      }
      // 如果后端返回的列表不含 BackCollar 面（旧数据），在前端追加
      if (!backCollarFace) {
        const backCollarNew = {
          id: 3,
          name: 'BackCollar',
          price: Number(rst.data["editorJson"]["backCollarPrice"] ?? 0).toFixed(2),
          frameX: 130,
          frameY: 180,
          frameWidth: BACK_COLLAR_FRAME_DISPLAY,
          frameHeight: BACK_COLLAR_FRAME_DISPLAY,
          materials: []
        };
        editorList.push(backCollarNew);
      }

      editorData.value = editorList;
      // 记录后端返回素材的原始尺寸，作为缩放百分比（100%）的基准
      editorList.forEach(x => {
        (x.materials || []).forEach(_rememberMaterialInitSize);
      });
      // 获取各面价格
      positions.value = [
        {
          value: 1,
          label: 'Front'
        },
        {
          value: 2,
          label: 'Back',
          price: Number(editorList.find(x => x.id == 2)?.["price"] ?? editorList[1]?.["price"] ?? 0).toFixed(2)
        },
        {
          value: 3,
          label: 'Back Collar',
          price: Number(editorList.find(x => x.id == 3)?.["price"] ?? 0).toFixed(2)
        }
      ];
      // 默认取正面价格
      unitPrice.value = Number(editorList[0]["price"]).toFixed(2);
      editHistory.value.push(editorList);
      currentHistoryIndex.value = 0;
      setTimeout(() => {
        const activeLayer = imageEditorRef["value"]?.getActiveData();
        sourceMaterialInfo.value = activeLayer;
        currentLayer.value = activeLayer?.id;
      }, 0)
      fontLoading.value = false;
    } catch (err) {
      fontLoading.value = false;
      console.error('Error to init:', err);
    }
  }

  /**
   * Finish
   * @returns {Promise<void>}
   */
  const onFinish = async () => {
    if (!hasAnyDesign.value) {
      ElMessage.warning("Please add a design on Front, Back, or Back Collar before finishing.");
      return;
    }
    containerLoading.value = true;
    let subList = _.cloneDeep(submitList.value);
    // 校验编辑器数据 需要至少包含两个面
    if (subList.length < 2) {
      ElMessage.error("Part of data is missing.");
      return;
    }
    // 将 editorData 中各面的 frame 信息（frameX/frameY/frameWidth/frameHeight）
    // 合并回 subList，防止编辑器事件返回的 list 缺少或使用了错误的 frame 值
    subList.forEach(face => {
      const initFace = editorData.value.find(x => x.id == face.id);
      if (initFace) {
        face.frameX = initFace.frameX;
        face.frameY = initFace.frameY;
        face.frameWidth = initFace.frameWidth;
        face.frameHeight = initFace.frameHeight;
      }
    });
    // 为字体素材对象的materialUrl 添加base64
    for (let i = 0; i < subList.length; i++) {
      const faceId = subList[i]["id"];
      // 导出字体素材base64
      const fontBase64 = await imageEditorRef["value"].exportMaterial(faceId);
      // 将字体素材替换到submitList中
      for (let j = 0; j < subList[i]["materials"].length; j++) {
        let fontItem = fontBase64.find(x => x.id === subList[i]["materials"][j]["id"])
        if (!_.isEmpty(fontItem)) {
          subList[i]["materials"][j]["materialUrl"] = fontItem["materialUrl"]
        }
      }
    }
    
    const reqParams = {
      designId,
      editorList: subList
    };
    
    try {
      const rst = await finish(reqParams);
      if (rst["code"] !== 0) {
        ElMessage.error(`Failed to finish：${rst["msg"]}`);
        return;
      }
      // 成功后将消息推送到iframe
      const responseData = {
        "designResult": rst["data"]
      };
    
      // console.log("成功后将消息推送到iframe " + JSON.stringify(responseData));

      window.parent.postMessage(responseData, '*');
    } catch (err) {
      console.error('Error to finish:', err);
    } finally {
      containerLoading.value = false;
    }
  }

  /**
   * 返回
   */
  const onBack = () => {
    // 成功后将消息推送到iframe
    const responseData = {
      "designResult": {
        "state": "close"
      }
    };
    window.parent.postMessage(responseData, '*');
  }

  /**
   * 后领区域新增文字后，将图层缩放到适合 63×63px frame 的大小并居中。
   * addText 是异步渲染的，需在 nextTick 后调用，此时 getActiveData() 已含实际宽高。
   */
  const _fitTextToBackCollar = () => {
    const backCollarMaxSize = 160;
    const backCollarFrame = { width: BACK_COLLAR_FRAME_DISPLAY, height: BACK_COLLAR_FRAME_DISPLAY };
    const liveFace = imageEditorRef["value"]?.getCurrentData();
    if (!liveFace || !liveFace.materials) return;
    // 优先用 currentLayer 定位，找不到则回退到 zIndex 最高的图层（刚添加的图层）
    let layerIndex = liveFace.materials.findIndex(m => m.id === currentLayer.value);
    if (layerIndex === -1) {
      const maxZ = Math.max(...liveFace.materials.map(m => m.zIndex || 0));
      layerIndex = liveFace.materials.findIndex(m => (m.zIndex || 0) === maxZ);
    }
    if (layerIndex === -1) return;
    const targetMaterial = liveFace.materials[layerIndex];
    if (!targetMaterial.width || !targetMaterial.height) return;
    const thumbSize = calculateThumbnailSize(targetMaterial.width, targetMaterial.height, backCollarMaxSize);
    const centerX = Math.round((backCollarFrame.width - thumbSize.width) / 2);
    const centerY = Math.round((backCollarFrame.height - thumbSize.height) / 2);
    const updatedMaterials = _.cloneDeep(liveFace.materials);
    updatedMaterials[layerIndex].width = thumbSize.width;
    updatedMaterials[layerIndex].height = thumbSize.height;
    updatedMaterials[layerIndex].x = centerX;
    updatedMaterials[layerIndex].y = centerY;
    _ensureTopZIndex(updatedMaterials, layerIndex);
    imageEditorRef["value"].setMaterials(liveFace.id, updatedMaterials);
  };

  /**
   * 增加文字图层
   */
  const onAddText = () => {
    if (!inputValue.value) return;
    imageEditorRef["value"].addText({ content: inputValue.value, id: Date.now().toString() });
    if (currentPosition.value === BACK_COLLAR_FACE_ID) {
      nextTick(() => _fitTextToBackCollar());
    }
    nextTick().then(() => {
      inputValue.value = ""
    })
  }

  /**
   * 文字素材input时
   */
  const onEditSave = () => {
    imageEditorRef["value"].replaceText(inputValue.value);
    nextTick().then(() => {
      isTextUpdate.value = false;
      inputValue.value = "";
    });
  }

  /**
   * 点击素材库
   * @param index 左侧选项卡索引
   */
  const onClickClipart = async (index) => {
    activeTab.value = index;
    clipartLoading.value = true;
    try {
      const rst = await getClipartList();
      if (rst["code"] !== 0) {
        clipartLoading.value = false;
        ElMessage.error(`Failed to get clipart：${rst["msg"]}`);
        return;
      }
      if (_.isEmpty(rst["data"])) {
        clipartLoading.value = false;
        return;
      }
      orignClipartList = Object.values(rst["data"]).map(category => ({
        ...category,
        clipart: Object.values(category.clipart)
      }));

      // 截取字符串，进行地址转发
      clipartList.value = orignClipartList.map(category => ({
        ...category,
        clipart: category.clipart.map(item => ({
          ...item,
          image: processUrl(item.image)
        }))
      }));
      clipartLoading.value = false;
    } catch (err) {
      clipartLoading.value = false;
      console.error('Get cliparts error:', err);
    }
  }

  /**
   * 处理字符串
   * @param url
   * @returns {string}
   */
  const processUrl = url => '/clipart' + (url.split('/images/clipart')[1] || '');

  /**
   * 点击已保存的素材
   * @param index 左侧选项卡索引
   * @returns {Promise<void>}
   */
  const onClickSaved = async (index) => {
    activeTab.value = index;
    savedAreaLoading.value = true;
    try {
      const rst = await getUserImages({encrypt});
      if (rst["code"] !== 0) {
        ElMessage.error(`Failed to get designs：${rst["msg"]}`);
        return;
      }
      savedDesignsList.value = Array.isArray(rst["data"]) ? rst["data"] : [];
      savedPage.value = 1;
      await resetSavedScroll();
    } catch (err) {
      console.error('Get saved designs error:', err);
    } finally {
      savedAreaLoading.value = false;
    }
  }

  // 已保存的设计 - 分页数据
  const savedDesignsTotal = computed(() => savedDesignsList.value.length);
  const savedPageCount = computed(() => Math.max(1, Math.ceil(savedDesignsTotal.value / savedPageSize.value)));
  const savedPageItems = computed(() => {
    const start = (savedPage.value - 1) * savedPageSize.value;
    return savedDesignsList.value.slice(start, start + savedPageSize.value);
  });
  // 已保存的设计 - 虚拟滚动可视区域
  const savedRowCount = computed(() => Math.ceil(savedPageItems.value.length / SAVED_ITEMS_PER_ROW));
  const savedStartRow = computed(() => {
    const startRow = Math.max(0,
        Math.floor(savedScrollTop.value / SAVED_ROW_HEIGHT) - SAVED_OVERSCAN_ROWS);
    return Math.min(startRow, Math.max(0, savedRowCount.value - 1));
  });
  const savedEndRow = computed(() => Math.min(savedRowCount.value,
      Math.ceil((savedScrollTop.value + savedViewportHeight.value) / SAVED_ROW_HEIGHT) + SAVED_OVERSCAN_ROWS));
  const savedVirtualOffset = computed(() => savedStartRow.value * SAVED_ROW_HEIGHT);
  const savedVirtualHeight = computed(() => savedRowCount.value * SAVED_ROW_HEIGHT);
  const savedVisibleDesigns = computed(() => savedPageItems.value.slice(
      savedStartRow.value * SAVED_ITEMS_PER_ROW,
      savedEndRow.value * SAVED_ITEMS_PER_ROW
  ));

  const handleSavedScroll = (e) => {
    savedScrollTop.value = e.target.scrollTop;
  };

  const updateSavedViewportHeight = () => {
    if (savedAreaRef.value) {
      savedViewportHeight.value = savedAreaRef.value.clientHeight;
    }
  };

  const resetSavedScroll = async () => {
    savedScrollTop.value = 0;
    await nextTick();
    if (savedAreaRef.value) {
      savedAreaRef.value.scrollTop = 0;
    }
    updateSavedViewportHeight();
  };

  const handleSavedPageChange = (page) => {
    savedPage.value = page;
    resetSavedScroll();
  };

  const handleSavedPageSizeChange = (size) => {
    savedPageSize.value = size;
    savedPage.value = 1;
    resetSavedScroll();
  };

  const observeSavedArea = () => {
    if (savedAreaResizeObserver) {
      savedAreaResizeObserver.disconnect();
      savedAreaResizeObserver = null;
    }
    const el = savedAreaRef.value;
    if (!el) return;
    updateSavedViewportHeight();
    savedAreaResizeObserver = new ResizeObserver(() => updateSavedViewportHeight());
    savedAreaResizeObserver.observe(el);
  };

  /**
   * 删除已保存的设计素材
   * @param item
   */
  const onDeleteSavedDesign = async (item) => {
    try {
      await ElMessageBox.confirm('Are you sure you want to delete this design?', 'Delete Design', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      });
    } catch {
      return;
    }

    try {
      const rst = await deleteUserImage({
        encrypt,
        folderPath: item.folderPath || '',
        fileName: item.thumbFileName || ''
      });
      if (rst["code"] !== 0) {
        ElMessage.error(`Failed to delete design：${rst["msg"]}`);
        return;
      }
      const index = savedDesignsList.value.findIndex(x =>
          (x.folderPath === item.folderPath && x.thumbFileName === item.thumbFileName)
          || x.imageUrl === item.imageUrl);
      if (index > -1) {
        savedDesignsList.value.splice(index, 1);
      }
      if (savedPage.value > savedPageCount.value) {
        savedPage.value = savedPageCount.value;
        await resetSavedScroll();
      }
      ElMessage.success('Design deleted');
    } catch (err) {
      console.error('Delete saved design error:', err);
    }
  }

  /**
   * 获取图片宽高
   * @param url
   * @returns {Promise<unknown>}
   */
  const getImageSizeAsync = async (url) => {
    const img = new Image();
    img.src = url;

    await new Promise((resolve, reject) => {
      img.onload = resolve;
      img.onerror = reject;
    });

    return {
      width: img.width,
      height: img.height,
      naturalWidth: img.naturalWidth,
      naturalHeight: img.naturalHeight
    };
  }

  /**
   * 计算缩略图尺寸，确保长边不超过指定最大值
   * @param {number} originalWidth - 原始宽度
   * @param {number} originalHeight - 原始高度
   * @param {number} maxSize - 最大边长
   * @returns {Object} 包含 width 和 height 的对象
   */
  const calculateThumbnailSize = (originalWidth, originalHeight, maxSize = 250) => {
    // 参数验证
    if (!originalWidth || !originalHeight || originalWidth <= 0 || originalHeight <= 0) {
      throw new Error('无效的图片尺寸');
    }

    let width, height;

    // 计算缩放比例
    if (originalWidth > originalHeight) {
      // 宽度是长边
      width = maxSize;
      height = Math.round((originalHeight * maxSize) / originalWidth);
    } else {
      // 高度是长边或正方形
      height = maxSize;
      width = Math.round((originalWidth * maxSize) / originalHeight);
    }

    // 确保最小尺寸为1
    width = Math.max(width, 1);
    height = Math.max(height, 1);

    return {
      width,
      height,
      originalWidth,
      originalHeight,
      scale: width / originalWidth  // 缩放比例
    };
  }

  /**
   * 点击素材库中的素材
   * @param item
   */
  const onClickClipartImage = async (item) => {
    try {
      const size = await getImageSizeAsync(item.image);
      // 后领区域（id=3）：使用更小的默认尺寸，正/背面保持原始比例
      if (currentPosition.value === 3) {
        const backCollarMaxSize = 160;
        const thumbSize = calculateThumbnailSize(size.width, size.height, backCollarMaxSize);
        imageEditorRef["value"].addImage({
          materialUrl: item.image,
          width: thumbSize.width,
          height: thumbSize.height,
        });
      } else {
        const thumbSize = calculateThumbnailSize(size.width, size.height);
        // 上传成功后加载到编辑器中 /Images用于代理转发，解决跨域问题
        imageEditorRef["value"].addImage({
          materialUrl: item.image,
          width: thumbSize.width,
          height: thumbSize.height
        });
      }
      // 新添加的图片默认放置在设计区中间
      nextTick(() => _centerActiveMaterialInFrame());
    } catch (error) {
      console.error('获取图片尺寸失败:', error);
    }
  }

  /**
   * 点击已存设计中的素材
   * @param item
   */
  const onClickSavedDesign = (item) => {
    // 后领区域（id=3）：使用更小的默认尺寸，正/背面保持原始比例
    if (currentPosition.value === BACK_COLLAR_FACE_ID) {
      const backCollarMaxSize = 160;
      const thumbSize = calculateThumbnailSize(item["thumbWidth"], item["thumbHeight"], backCollarMaxSize);
      imageEditorRef["value"].addImage({
        materialUrl: item.imageUrl,
        width: thumbSize.width,
        height: thumbSize.height,
      });
    } else {
      imageEditorRef["value"].addImage({
        materialUrl: item.imageUrl,
        width: item["thumbWidth"],
        height: item["thumbHeight"]
      });
    }
    // 新添加的图片默认放置在设计区中间
    nextTick(() => _centerActiveMaterialInFrame());
  }

  /**
   * 素材库搜索框输入时
   * @param e 输入值
   */
  const onClipartSearchInput = (e) => {
    clipartList.value = searchClipartsByName(e);
  }

  const searchClipartsByName = (keyword) => {
    const normalizedKeyword = keyword.toLowerCase().trim();
    // 如果关键词为空，返回所有数据
    if (!normalizedKeyword) {
      return orignClipartList;
    }
    // 过滤每个分类中的 clipart
    return orignClipartList
        .map(x => {
          const filteredClipart = x.clipart.filter(item =>
              item.name.toLowerCase().includes(normalizedKeyword)
          );

          // 只返回有匹配结果的分类
          return filteredClipart.length > 0
              ? {...x, clipart: filteredClipart}
              : null;
        })
        .filter(item => item !== null); // 移除空分类
  }

  // region watch

  /**
   * 切换后背/后领时互斥检查
   * Back(id=2) 与 Back Collar(id=3) 不能同时有设计，切换到其中一面时，
   * 若另一面已有素材则弹框确认，确认后清空另一面，取消则回退选择。
   */
  const onPositionChange = async (newVal) => {
    // 仅对 Back 和 Back Collar 之间的互斥做检查
    if (newVal === 2 || newVal === 3) {
      const conflictId = newVal === 2 ? 3 : 2;
      const conflictFace = submitList.value.find(x => x.id == conflictId);
      if (conflictFace?.['materials']?.length) {
        const conflictName = conflictId === 2 ? 'Back' : 'Back Collar';
        // 有冲突：强制回退到原来的 tab（先清再赋，确保响应式触发重渲染）
        currentPosition.value = null;
        await nextTick();
        currentPosition.value = conflictId;
        await ElMessageBox.alert(
          `Can't be combined with ${conflictName} placement. To use it, remove the design from the selected placement.`,
          'Cannot Switch',
          {
            confirmButtonText: 'OK',
            type: 'warning',
            showClose: false
          }
        );
        return;
      }
    }
    // 无冲突：正常切换
    currentPosition.value = newVal;
  };

  // 监听方向变化 前胸/后背
  watch(
      () => currentPosition.value,
      (value) => {
        if (!value) return;
        imageEditorRef["value"]?.toggleCurrent(value);
        sourceMaterialInfo.value = imageEditorRef["value"]?.getActiveData();
        // 当前素材面
        sourceMaterialList.value = imageEditorRef["value"]?.getCurrentData()?.["materials"];
      }
  );

  // 监听当前素材变化
  watch(
      () => sourceMaterialInfo.value,
      (value) => {
        if (!_.isEmpty(value)) {
          // 记录素材初始尺寸，作为缩放百分比（100%）的基准
          _rememberMaterialInitSize(value);
          fontSize.value = value.fontSize;
          letterSpacing.value = value.letterSpacing;
          lineHeight.value = value.lineHeight;
          color.value = value.color;
          familyValue.value = {
            family: value.fontFamily,
            url: value.fontFamilyUrl
          };
          // 更新打印尺寸和位置
          calculatePrintSize();
          calculatePrintPosition();
          calculateTransform();
          return;
        }

        // 重置初始值
        fontSize.value = 20;
        letterSpacing.value = 0;
        lineHeight.value = 1.5;
        color.value = void '';
        printWidth.value = 0;
        printHeight.value = 0;
        printLeft.value = 0;
        printTop.value = 0;
        rotateDeg.value = 0;
        scalePercent.value = 100;
        // 切换图层时退出文字编辑状态
        isTextUpdate.value = false;
        inputValue.value = '';
      }
  );
  // 监听已保存设计滚动区域挂载/卸载，初始化虚拟滚动视口
  watch(savedAreaRef, observeSavedArea);

  // endregion

  onMounted(() => {
    // 无参数时不作请求
    if (_.isEmpty(encrypt)) {
      allowAccess.value = false
      // 可以在这里记录错误或发送通知
      console.error('参数无效')
      return;
    } else {
      allowAccess.value = true
    }
    // 先挂载字体文件
    getFonts().then(() => {
      editorInit();
    });
  })

  onBeforeMount(() => {
    // 检查是否在iframe中
    const isInIframe = window.self !== window.top;

    if (!isInIframe) {
      allowAccess.value = false
      // 可以在这里记录错误或发送通知
      console.error('此页面必须在iframe中打开')
    } else {
      allowAccess.value = true
    }
  })

  onBeforeUnmount(() => {
    savedAreaResizeObserver?.disconnect();
    savedAreaResizeObserver = null;
  })
</script>

<style scoped lang="scss">
  .marginBottom16 {
    margin-bottom: 16px;
  }

  .container {
    height: 100%;
    overflow: hidden;

    .header {
      padding: 0;
      background: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .headerLeft {
        display: flex;
        align-items: center;

        .iconLeft {
          margin: 0 32px;
          cursor: pointer;
        }

        .el-divider {
          height: 72px;
        }

        .info {
          font-size: 16px;
          color: #333333;

          .code {
            margin-top: 10px;
          }
        }
      }

      .headerCenter {
        width: 600px;

        .el-steps {
          margin: 0 auto;

          :deep(.el-step__head.is-success) {
            .el-step__icon.is-text {
              background: #3A499D;
              border-color: #3A499D;
              color: #ffffff;
            }
          }

          :deep(.el-step__title.is-success) {
            color: #3A499D;
            font-weight: bold;
          }

          :deep(.el-step__head.is-process) {
            .el-step__icon.is-text {
              background: #889AFF;
              border-color: #889AFF;
              color: #ffffff;
            }
          }

          :deep(.el-step__title.is-process) {
            color: #889AFF;
            font-weight: bold;
          }
        }
      }

      .headerRight {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 48px;
        margin-right: 48px;

        .undoRedo {
          display: flex;
          align-items: center;
        }
      }
    }

    .positionRow {
      display: flex;
      align-items: center;
      justify-content: center;

      .el-segmented {
        height: 44px;
        font-weight: bolder;
        font-size: 18px;
        color: #3A489E;
        --el-segmented-item-selected-color: #ffffff;
        --el-segmented-item-selected-bg-color: #3A489E;
        --el-segmented-item-hover-color: #889AFF;
        --el-segmented-bg-color: #f5f5f5;
        --el-border-radius-base: 28px;
        --el-segmented-padding: 0;

        :deep(.el-segmented__item) {
          padding: 0 20px;
          border: 1px solid #3A489E;
          background: #ffffff;
          width: 200px;
          box-sizing: border-box;
        }

        :deep(.el-segmented__group) {
          gap: 18px;
        }
      }
    }

    .editorArea {
      border-top: 1px solid #e8e8e8;
      min-width: 0;
      overflow: hidden;

      .leftArea {
        border-right: 1px solid #e8e8e8;
        height: 100%;
        overflow-y: auto;

        .actions {
          padding: 8px 0;

          :deep(.el-upload) {
            width: 100%;
          }

          :deep(.el-upload__tip) {
            margin-bottom: 12px;
          }

          .el-button {
            width: 100%;
            background: #3A499D;
            color: #ffffff;
            height: 44px;
            border-radius: 40px;
            margin: 0;
            font-size: 18px;
            font-weight: bold;

            .el-icon {
              margin-right: 16px;
            }

            &.is-disabled {
              color: #AAAAAA;
            }
          }
        }

        &.menus {
          padding: 8px;

          .menuItem {
            background: #F5F5F5;
            border-radius: 6px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 8px;
            height: 80px;
            color: #000000;
            font-size: 14px;
            cursor: pointer;
            margin-bottom: 8px;
            text-align: center;

            &.active {
              background: #3A489E;
              color: #ffffff;
            }

            &.active:hover {
              background: #3A489E;
            }

            &:hover {
              background: #ececec;
            }
          }
        }

        .areaTitle {
          color: #000000;
          font-weight: bold;
          font-size: 18px;
          border-bottom: 1px solid #e8e8e8;
          padding: 12px;
        }

        .mainArea {
          padding: 16px 12px;

          .row {
            span {
              font-weight: bold;
              color: #B80801;
            }

            margin-bottom: 16px;
          }
        }

        .clipartItem {
          .title {
            font-size: 18px;
            color: #000000;
            font-weight: bold;
            margin-bottom: 16px;
          }

          .list {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            gap: 16px;
          }

          img {
            cursor: pointer;
            width: 88px;
            height: 88px;
            object-fit: scale-down;
          }
        }

        &.savedDesignsArea {
          display: flex;
          flex-direction: column;
          overflow: hidden;
        }

        .savedArea {
          position: relative;
          flex: 1;
          min-height: 0;
          overflow-y: auto;
          padding: 16px;

          .savedVirtualHolder {
            position: relative;
            width: 100%;
          }

          .savedVirtualList {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            display: flex;
            flex-wrap: wrap;
            gap: 16px;
          }

          .savedItem {
            width: 188px;
            height: 266px;
            font-size: 14px;
            color: #666666;

            .savedItemImage {
              position: relative;
              width: 188px;
              height: 188px;
              margin-bottom: 4px;

              .savedDeleteBtn {
                position: absolute;
                top: 6px;
                right: 6px;
                width: 26px;
                height: 26px;
                border-radius: 50%;
                background: rgba(0, 0, 0, .55);
                color: #ffffff;
                cursor: pointer;
                opacity: 0;
                transition: opacity .2s;
              }
            }

            &:hover .savedDeleteBtn {
              opacity: 1;
            }

            img {
              display: block;
              width: 188px;
              height: 188px;
              object-fit: scale-down;
              border: 1px solid #eeeeee;
              cursor: pointer;
              /*马赛克格子背景*/
              background-color: #fff;
              background-image: linear-gradient(45deg, #eee 25%, transparent 25%),
              linear-gradient(-45deg, #eee 25%, transparent 25%),
              linear-gradient(45deg, transparent 75%, #eee 75%),
              linear-gradient(-45deg, transparent 75%, #eee 75%);
              background-size: 20px 20px;
              background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
            }

            .title {
              color: #000000;
              margin-bottom: 8px;
              font-weight: bold;
            }

            .content {
              margin-bottom: 4px;
            }
          }
        }

        .savedPagination {
          flex: 0 0 auto;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 8px 12px 12px;
          border-top: 1px solid #e8e8e8;

          .savedPageSize {
            width: 104px;
            flex: 0 0 auto;
          }
        }
      }

      .layersTitle {
        padding: 16px;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #e8e8e8;

        span {
          font-size: 12px;
          color: var(--el-text-color-regular);

          &.warning {
            color: #ff0000;
          }
        }
      }

      .layersList {
        padding: 12px;
        overflow-y: auto;

        .layerItem {
          border: 1px solid #e3e3e3;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 6px 0;
          margin-bottom: 8px;
          cursor: pointer;

          &.active {
            border-color: #3A499D;
            background: #D9DFFF;
          }

          &:hover {
            border-color: #c3c3c3;
          }

          .itemLeft {
            flex: 1;
            display: flex;
            align-items: center;
            font-size: 16px;

            .leftIcon {
              width: 24px;
            }

            .layerImg {
              width: 50px;
              height: 50px;
              object-fit: contain;
              margin-right: 12px;
            }
          }

          .rightIcon {
            width: 36px;

            &:hover {
              color: #ff0000;
            }
          }
        }
      }

      .rightArea {
        border-left: 1px solid #e8e8e8;
        padding: 0 16px 32px;
        overflow-x: hidden;
        overflow-y: auto;
        height: calc(100vh - 180px);

        .title {
          font-weight: bold;
          font-size: 18px;
          margin-bottom: 16px;
        }

        .flexRow {
          display: flex;
          align-items: center;
          gap: 16px;

          .caption {
            font-weight: bold;
            width: 130px;
            font-size: 18px;
          }

          :deep(.el-slider__bar) {
            background-color: #3A499D;
          }

          :deep(.el-slider__button) {
            border-color: #3A499D;
          }
        }

        .iconSingle {
          color: #333333;
          cursor: pointer;
        }

        .iconOption {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          border: 1px solid #333333;
          border-radius: 20px;
          padding: 4px 16px;
          font-size: 16px;
          color: #333333;
          cursor: pointer;
          white-space: nowrap;
          font-weight: bold;

          &:hover {
            color: #3A499D;
            border-color: #3A499D;
          }
        }

        .color-picker {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 11px;

          :deep(.el-tooltip__trigger) {
            width: 24px;
            height: 24px;
          }

          :deep(.el-color-picker__empty) {
            background: conic-gradient(
                    from 90deg at 50% 50%,
                    rgb(255, 0, 0) -19.41deg,
                    rgb(255, 0, 0) 18.76deg,
                    rgb(255, 138, 0) 59.32deg,
                    rgb(255, 230, 0) 99.87deg,
                    rgb(20, 255, 0) 141.65deg,
                    rgb(0, 163, 255) 177.72deg,
                    rgb(5, 0, 255) 220.23deg,
                    rgb(173, 0, 255) 260.13deg,
                    rgb(255, 0, 199) 300.69deg,
                    rgb(255, 0, 0) 340.59deg,
                    rgb(255, 0, 0) 378.76deg
            );
            height: 100%;
            width: 100%;

            & > svg {
              display: none;
            }
          }

          :deep(.el-color-picker__trigger) {
            width: 24px;
            height: 24px;
            padding: 0;
            border: none;

            .el-color-picker__color {
              border-radius: 50%;
              border: none;
              overflow: hidden;
              box-shadow: 0 0 2px rgba(100, 100, 100, .8);
            }
          }
        }

        .color-item {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          cursor: pointer;
          box-shadow: 0 0 2px rgba(100, 100, 100, .8);
        }

        .printSizeUnit {
          font-size: 14px;
          color: #666666;
          margin-left: 4px;
          white-space: nowrap;
        }

        .printSizeHeader {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 12px;
        }

        .printSizeLock {
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .printSizeLockLabel {
          font-size: 12px;
          color: #666666;
        }

        .printSizeGrid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
          margin-bottom: 16px;

          .printSizeItem {
            display: flex;
            flex-direction: column;
            gap: 6px;

            .printSizeLabel {
              font-size: 14px;
              font-weight: bold;
              color: #333333;
            }

            :deep(.el-input__suffix) {
              color: #666666;
              font-size: 13px;
            }
          }

          .printSizeItemInline {
            display: flex;
            align-items: center;
            gap: 8px;

            .printSizeLabel {
              font-size: 14px;
              font-weight: bold;
              color: #333333;
              white-space: nowrap;
              width: 44px;
              flex-shrink: 0;

              &.wide {
                width: 52px;
              }
            }

            :deep(.el-input__suffix) {
              color: #666666;
              font-size: 13px;
            }
          }
        }
      }

      .centerArea {
        background: #F5F5F5;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: hidden;
        position: relative;
        min-width: 0;

        .editorContainer {
          width: 100%;
          height: calc(100vh - 100px - 80px - 100px);
          overflow: auto;
          padding-top: 24px;
          background: #ffffff;
          box-shadow: 0 0 4px rgba(100, 100, 100, .1);
          border-radius: 16px;
          display: flex;
          justify-content: center;
        }

        .footerBar {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 9;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          gap: 24px;
          background: #ffffff;
          box-shadow: 0 0 4px rgba(100, 100, 100, .2);
          height: 64px;

          .unitPrice {
            font-weight: bolder;
            color: #333333;

            b {
              color: #C60003;
              margin-left: 4px;
              font-size: 20px;
            }
          }

          .finishButton {
            height: 45px;
            border-radius: 60px;
            width: 140px;
            font-size: 22px;
            font-weight: bold;
          }
        }
      }
    }
  }

  .custom-progress {
    margin-top: 20px;
    padding: 15px;
    background: #f5f7fa;
    border-radius: 4px;
  }

  .progress-info {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    font-size: 12px;
    color: #909399;
  }

  :deep(.el-loading-spinner) {
    top: 200px;
  }

  /* 强制用 display:none 彻底隐藏非活跃面的 canvas，
     防止 visibility:hidden 在某些渲染场景下仍叠显 */
  :deep(.leafer-editor-hide) {
    display: none !important;
  }

  .error-container {
    margin-left: 16px;
  }
</style>